/* eslint-disable no-throw-literal */
import {
  SHOP_ORDERS_ALL_GET,
  SHOP_ORDER_GET,
  SHOP_ORDER_HOLD_ON_PLACES,
  SHOP_ORDER_SUPPLIERS,
  SHOP_ORDER_UPDATE,
  SHOP_ORDER_UPDATE_ALL,
  SHOP_ORDERS_HISTORY_LIST,
  SHOP_ORDERS_HISTORY_SEARCH_ITEM_GET,
  GET_STOCK_AVAILABLE_DATE,
  STOCK_ANALYSIS_CSV
} from './mutation-types'

export default {
  actions: {
    async [SHOP_ORDERS_ALL_GET] ({dispatch, state, commit}, params = {}) {
      const res = await dispatch('apiGet', {url: '/stock/shop_orders', data: params})
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res
    },
    async [SHOP_ORDER_GET] ({dispatch, state, commit}, params = {}) {
      const res = await dispatch('apiGet', {url: `/stock/shop_orders/${params.id}`, data: {}})
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res
    },
    async [SHOP_ORDER_HOLD_ON_PLACES] ({dispatch, state, commit}, params = {}) {
      const res = await dispatch('apiGet', {url: '/stock/shop_order_details/shop_order_hold_on_place_list', data: params})
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res
    },
    async [SHOP_ORDER_SUPPLIERS] ({dispatch, state, commit}, params = {}) {
      const res = await dispatch('apiGet', {url: '/stock/shop_order_details/shop_order_supplier_list', data: params})
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res
    },
    async [SHOP_ORDER_UPDATE] ({dispatch, state, commit}, params = {}) {
      const res = await dispatch('apiPatch', {url: `/stock/shop_orders/${params.id}`, data: params})
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res
    },
    async [SHOP_ORDER_UPDATE_ALL] ({dispatch, state, commit}, params = {}) {
      const res = await dispatch('apiPatch', {url: '/stock/shop_orders/update_all', data: params})
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res
    },
    async [SHOP_ORDERS_HISTORY_LIST] ({dispatch, state, commit}, params = {}) {
      const res = await dispatch('apiGet', {url: '/stock/shop_orders/history_list', data: params})
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res
    },
    async [SHOP_ORDERS_HISTORY_SEARCH_ITEM_GET] ({dispatch, state, commit}, params = {}) {
      const res = await dispatch('apiGet', {url: '/stock/shop_orders/items_for_search', data: params})
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res
    },
    async [GET_STOCK_AVAILABLE_DATE] ({dispatch}, params = {}) {
      const res = await dispatch('apiGet', {url: '/master/shop_orders/get_stock_available_date', data: params})
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [STOCK_ANALYSIS_CSV] ({dispatch}, params = {}) {
      const res = await dispatch('apiGet', {url: '/master/shop_orders/stock_analysis_csv', data: params})
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/shop-orders.js